import { Box, Container } from '@mui/material';
import HomeSection from './components/landingPage/homeSection/HomeSection';
import Curriculum from './components/landingPage/curriculumSection/Curriculum';
import WhyUsSection from './components/landingPage/whyUsSection/WhyUsSection';
import HowItWorks from './components/landingPage/howItWorksSection/HowItWorks';
import Project from './components/landingPage/projectsSections/Project';
import Contact from './components/landingPage/contactSection/Contact';
import Accordion from './components/landingPage/accordionSection/FAQ';
import Footer from './components/landingPage/footerSection/Footer';

function Main() {
  return (
    <Box sx={{
      width: '100%', backgroundColor: '#002853', color: '#fff', padding: '20px 0',
    }}
    >
      <Container>
        <HomeSection />
        <Curriculum />
        <WhyUsSection />
        <HowItWorks />
        <Project />
        <Contact />
        <Accordion />
        <Footer />
      </Container>
    </Box>
  );
}

export default Main;
